import React from 'react'

export default () => (
  <div>
    <h1>Admin</h1>
  </div>
)
